/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { saveAll } from '../../store/items';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import {
  setCurrentMobileTab,
  setCurrentTab,
  setOpenModales,
} from '../../store/global';
import { FaLink, FaImages } from 'react-icons/fa';
import { TiSortNumerically, TiSortAlphabetically } from 'react-icons/ti';
import { MdSmartButton } from 'react-icons/md';
import { TabSettings } from './tab.Settings';
import { renderIconByLabel } from '../../content/icons';
import { getId, canEditItemForItem } from '../../utils/item';
import { canUseMjForItem, isMjForItem } from '../../utils/auth';

const isValidObjectId = id => typeof id === 'string' && /^[a-f0-9]{24}$/i.test(id);

export const TabSortable = props => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: props.id });
  const { tabId, itemId, isOnMobile, mobileCurrentTab, useMobileTabState } =
    props;
  const draggable = props?.draggable !== false;

  const item = useSelector(state => state.items[itemId]);
  const tab = useSelector(state => state.items[tabId]);
  const currentTab = useSelector(state => state.global.currentTab);
  const items = useSelector(state => state.items);
  const dispatch = useDispatch();
  const usePerItemTabState = useMobileTabState || isOnMobile === true;
  const activeTabId = usePerItemTabState ? mobileCurrentTab : currentTab;
  const isHardReadOnly = tab?.readOnlyMode === 'hard';
  const canBypassHardReadOnly =
    isMjForItem(tab, items) || canUseMjForItem(tab, items);

  const [tabColor, setTabColor] = useState(null);

  const tabRef = useRef(null);

  const setRef = ref => {
    setNodeRef(ref);
    tabRef.current = ref;
  };

  const getItems = async id => {
    if (!isValidObjectId(id)) {
      return;
    }
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/items/${id}`);
      if (res?.data?._id) {
        dispatch(saveAll({ item: res.data }));
      }
    } catch (error) {
      // silent: missing tab item should not spam console
    }
  };

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  useEffect(() => {
    if (item?.tabs) {
      const tabConfig = item.tabs.find(tabObj => getId(tabObj) === tabId);
      if (tabConfig) {
        setTabColor(tabConfig[tabId]?.color ?? 'primary-d');
      }
    }
  }, [item?.tabs]);

  useEffect(() => {
    if (isValidObjectId(tabId) && !items[tabId]) {
      getItems(tabId);
    }
  }, [tabId, items]);

  useEffect(() => {
    if (tabRef?.current) {
      if (tabRef.current.id === activeTabId) {
        tabRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }
  }, [activeTabId]);

  const setDefaultTabs = () => {
    switch (tabId) {
      case 'text':
        return (
          <div className='flex items-center gap-05'>
            <TiSortAlphabetically /> Textes
          </div>
        );

      case 'img':
        return (
          <div className='flex items-center gap-05'>
            <FaImages /> Images
          </div>
        );

      case 'link':
        return (
          <div className='flex items-center gap-05'>
            <FaLink /> Liens
          </div>
        );

      case 'num':
        return (
          <div className='flex items-center gap-05'>
            <TiSortNumerically /> Nombres
          </div>
        );

      case 'conditions':
        return (
          <div className='flex items-center gap-05'>
            <MdSmartButton /> Boutons
          </div>
        );

      default:
        break;
    }
  };

  return (
    <div
      id={tabId}
      ref={setRef}
      {...(draggable ? attributes : {})}
      {...(draggable ? listeners : {})}
      style={style}
      // className={`flex h-full items-center gap-05 py-05 px-1 cursor-pointer whitespace-nowrap ${
      //   currentTab === tabId ? 'bg-primary-d bg-opacity-75' : ''
      // }`}
      className='relative'
      onClick={() =>
        usePerItemTabState
          ? dispatch(setCurrentMobileTab({ itemId, tabId }))
          : dispatch(setCurrentTab(tabId))
      }
      onDoubleClick={e => {
        e.stopPropagation();
        if (!canEditItemForItem(tab, items)) return;
        if (isHardReadOnly && !canBypassHardReadOnly) return;
        tabId !== 'link' &&
          tabId !== 'img' &&
          tabId !== 'text' &&
          tabId !== 'num' &&
          tabId !== 'conditions' &&
          dispatch(setOpenModales({ id: tabId, open: true }));
      }}
    >
      <div
        className={` ${
          activeTabId === tabId
            ? 'bg-gradient-to-b from-main to-primary-d absolute py-07'
            : ''
        }`}
        style={{
          width: '120%',
          marginLeft: '-10%',
          paddingLeft: '10%',
          bottom: 0,
          zIndex: 0,
        }}
      ></div>
      <div
        className={`rounded-br-lg ${
          activeTabId === tabId ? 'bg-main absolute py-07' : ''
        }`}
        style={{
          width: '10%',
          marginLeft: '-10%',
          paddingLeft: '10%',
          bottom: 0,
          zIndex: 0,
        }}
      ></div>
      <div
        className={`rounded-bl-lg ${
          activeTabId === tabId ? 'bg-main absolute py-07' : ''
        }`}
        style={{
          width: '10%',
          marginLeft: '100%',
          paddingLeft: '10%',
          bottom: 0,
          zIndex: 0,
        }}
      ></div>

      <div
        style={{ zIndex: 1 }}
        className={`relative rounded-tl-lg rounded-tr-lg flex h-full items-center gap-05 py-05 px-1 cursor-pointer whitespace-nowrap transition-all hover:opacity-75 ${
          activeTabId === tabId
            ? `bg-gradient-to-b from-${tabColor}/25 to-primary-d`
            : ''
        }`}
      >
        <TabSettings
          tabId={tabId}
          itemId={itemId}
        />
        {!tab?.label && setDefaultTabs()}
        {renderIconByLabel(tab?.icon, { size: isOnMobile ? 25 : 20 })}
        {isOnMobile !== true && tab?.label}
      </div>
    </div>
  );
};
